import { DEFAULT_SITE } from "../../../../constants";

export const logSheetSelectSuggestion = (item, { loadInstrumentSuggestion = null, formik, user }) => {
  if (loadInstrumentSuggestion) {
    loadInstrumentSuggestion(item);
  }
  formik.setValues({
    ...formik.values,
    site: formik.values?.site ?? user.site ?? DEFAULT_SITE,
    approverId: user?.user ?? "",
    approverUserName: user.name ?? "",
    equipmentId: item.equipmentId,
    serialNumber: item.serialNumber,
    materialNumber: item.materialNumber,
    equipmentModel: item?.equipmentModel,
    equipmentNickName: item?.equipmentNickName ?? item?.equipmentDetails?.equipmentNickName ?? "",
    isClusterQualificationChanged: !item?.isClusterQualificationChanged,
    inventoryId: item?.inventoryId ?? item?.id ?? "",
    instrumentDetails: {
      ...formik.values.instrumentDetails,
      configurationBaseline: item.configurationBaseline,
      instrumentGxPStatus: item?.qualificationStatus || "",
      equipmentNickName: item?.equipmentNickName,
      responsiblePerson: item.responsiblePerson,
      manufacturer: item.manufacturer,
      softwareVersion: item.softwareVersion,
      location: item.location,
      responsibleProxy: item.responsibleProxy
    }
  });
};
